import React from 'react';
import { Link } from 'react-router-dom';
import homeabout from '../../assets/homeabout.png';

export default function HomeAbout() {
  return (
    <section className="bg-white py-16 sm:py-20 lg:py-24" aria-labelledby="home-about-heading">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center lg:gap-14">
          <div>
            <img
              src={homeabout}
              alt="Blister packs of assorted prescription medications on a white surface"
              className="aspect-[4/3] w-full rounded-2xl object-cover shadow-lg ring-1 ring-slate-200/80 lg:aspect-auto lg:min-h-[22rem]"
              loading="lazy"
            />
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-brand-700">About MedIntel</p>
            <h2
              id="home-about-heading"
              className="mt-2 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl"
            >
              Reporting medicine with clarity and rigor
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-600">
              We connect clinical evidence, guidelines, and the stories behind new drugs and devices—so readers
              can see what was studied, what changed, and what still needs better data.
            </p>
            <p className="mt-4 leading-relaxed text-slate-600">
              Our writers prioritize transparency: effect sizes, adverse events, study limits, and where expert
              opinion diverges. Whether you follow medicine for work or for your own care, you get context—not
              just headlines.
            </p>
            <p className="mt-4 leading-relaxed text-slate-600">
              We follow stories from early signals through peer-reviewed publication, regulatory decisions, and
              how guidance evolves in practice—calling out mixed evidence and separating what a trial measured from
              what people assume happened in real-world care.
            </p>
            <p className="mt-4 leading-relaxed text-slate-600">
              Coverage spans new therapies and devices, public health, diagnostics, health systems, and research
              integrity. We are here to clarify the science and tradeoffs—not to replace your clinician or your own
              judgment.
            </p>
            <div className="mt-8 flex justify-center">
              <Link
                to="/about"
                className="inline-flex items-center justify-center rounded-md bg-brand-500 px-6 py-3 text-sm font-semibold text-white shadow-md shadow-brand-900/15 transition hover:bg-brand-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500"
              >
                Read more
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
